import { combineReducers } from '@reduxjs/toolkit';

import CustomerAuthReducer from './slices/CustomerAuthSlice';
import CustomerBlogReducer from './slices/CustomerBlogSlice';
import CustomerCartReducer from './slices/CustomerCartSlice';
import CustomerCheckoutReducer from './slices/CustomerCheckoutSlice';
import CustomerCompareReducer from './slices/CustomerCompareSlice';
import customerGlobalReducer from './slices/CustomerGlobalSlice';
import CustomerProductReducer from './slices/CustomerProductSlice';
import CustomerWishListReducer from './slices/CustomerWishListSlice';

const CustomerReducer = combineReducers({
  auth: CustomerAuthReducer,
  customerBlog: CustomerBlogReducer,
  customerProduct: CustomerProductReducer,
  customerCart: CustomerCartReducer,
  customerCompare: CustomerCompareReducer,
  customerWishList: CustomerWishListReducer,
  customerCheckout: CustomerCheckoutReducer,
  customerGlobal: customerGlobalReducer,
});
// Customer STATE TYPE
export type CustomerState = ReturnType<typeof CustomerReducer>;
export default CustomerReducer;
